import type { UpdateProjectionsByCSVRequest } from '@library/types/projection';
import { UploadCSV } from '@bo-components/common/UploadCSVBase';
import { useUploadProjectionsByCSVMutation } from '@bo-services/projectionsApi';

export const UploadProjectionsCSV = () => {
  const [
    uploadProjectionsByCSV,
    { error, isError, isLoading, isSuccess, isUninitialized, reset }
  ] = useUploadProjectionsByCSVMutation();

  const handleFileUpload = async (uploadFile: File | null) => {
    if (!uploadFile) {
      return;
    }

    const fileUrl = URL.createObjectURL(uploadFile);
    const response = await fetch(fileUrl);
    const text = await response.text();

    const request: UpdateProjectionsByCSVRequest = {
      csv: text,
      skip_start_time_validation: window.backoffice?.isAutomatedTesting
    };

    uploadProjectionsByCSV(request).catch(() => {});
  };

  return (
    <UploadCSV
      buttonText="Import projections"
      handleFileUpload={handleFileUpload}
      error={error}
      isError={isError}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isUninitialized={isUninitialized}
      reset={reset}
    />
  );
};
